import InsightsCaughtUp from '@static/images/empty-state/insights-caught-up.svg';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { FocusStreamFilterTabs } from '~/views/stream/components/stream-type-tab-line/StreamTypeTabLine';

import { OverviewEventFeedPeriod } from '../../utils';
import styles from './NoEvents.module.scss';

const NO_EVENTS_CONTENT_KEY: Record<FocusStreamFilterTabs, string> = {
  all: 'noEventsContent_all',
  company_catalyst: 'noEventsContent_company_catalyst',
  scenarios: 'noEventsContent_scenarios',
  earnings: 'noEventsContent_earnings',
};

export const NoEvents = ({
  activeTab,
  period,
}: {
  activeTab: FocusStreamFilterTabs;
  period: OverviewEventFeedPeriod;
}) => {
  const { t } = useTranslation(['whatsNew']);

  const title = t('whatsNew:noEventsEmpty', {
    /* i18next-extract-mark-context-next-line  ["all", "company_catalyst", "scenarios", "earnings"] */
    content: t(`whatsNew:${NO_EVENTS_CONTENT_KEY[activeTab]}`),
    /* i18next-extract-mark-context-next-line  ["1D", "3D", "1W", "1M"] */
    periodRange: t(`whatsNew:noEventsPeriodRange_${period}`),
  });

  return (
    <div className={styles.root} data-testid="overview-event-feed-no-insights">
      <InsightsCaughtUp width="56px" height="56px" />
      <div className={styles.descriptionText}>
        <div className={styles.titleText}>{title}</div>
      </div>
    </div>
  );
};
